import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import 'code-highlight/lib/style.css';
import 'highlight.js/styles/github-gist.css';

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'MultiSelectbox',
    breadcrumbName: 'MultiSelectbox',
  },
];

const MultiSelectbox = () => {
  useEffect(() => {
    new IMI.MultiSelectbox(document.getElementById('multiselect'));
    new IMI.MultiSelectbox(document.getElementById('multiselect2'));
  }, []);

  return (
    <>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="MultiSelectbox-single" style={{ padding: 10 }}/>

      <div className="MF_area">
        <div id="multiselect">
          <div data-drag="true">
            <div>item1</div>
            <div>item2</div>
            <div>item3</div>
            <div>item4</div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div id="multiselect">
  <div data-drag="true">
    <div>item1</div>
    <div>item2</div>
    <div>item3</div>
    <div>item4</div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Navigations" breadcrumb={{ routes }} subTitle="MultiSelectbox-double" style={{ padding: 10 }}/>

      <div className="MF_area">
        <div id="multiselect2">
          <div data-drag="true">
            <div>item1</div>
            <div>item2</div>
            <div>item3</div>
            <div>item4</div>
          </div>
          <div data-drag="true">
            <div>item5</div>
            <div>item6</div>
            <div>item7</div>
            <div>item8</div>
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div id="multiselect2">
  <div data-drag="true">
    <div>item1</div>
    <div>item2</div>
    <div>item3</div>
    <div>item4</div>
  </div>
  <div data-drag="true">
    <div>item5</div>
    <div>item6</div>
    <div>item7</div>
    <div>item8</div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
};

export default MultiSelectbox;
